import { MailOutlined } from '@ant-design/icons';
import { useCreation } from '@umijs/hooks';
import { Button, Col, Empty, Input, Row, Spin } from 'antd';
import { MONITORING, TIKETS } from 'api';
import each from 'lodash/each';
import filter from 'lodash/filter';
import get from 'lodash/get';
import map from 'lodash/map';
import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import uniqBy from 'lodash/uniqBy';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
// import Footer from './components/Footer';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import useFetch from 'utils/fetch/useFetch';
import request from 'utils/request';
import Filter from '../../components/Filter/index';
import { ReactComponent as Plane } from '../../images/plane.svg';
import { setCount, setId } from '../../store/reducers/chatSlice';
import { fetchSuccess } from '../../store/reducers/fetchSlice';
import Bar from './components/Bar';
import Message from './components/Message';
const Wrapper = styled.div`
  &&& {
    .ant-input {
      height: 44px;
      border-radius: 12px !important;
      padding-right: 47px;
      overflow: hidden;
      &:focus::placeholder {
        opacity: 0;
      }
      &::placeholder {
        padding-top: 6px;
      }
    }
    .ant-input-group-addon {
      background: none;
      border: none;
      position: absolute;
      right: 37px;
      top: 6px;
      z-index: 100;
      cursor: pointer;
    }
  }
`;

function Chat({}) {
  const idTiket = useSelector((state) => get(state, `chat.idTiket`, null));
  const countMess = useSelector((state) => get(state, `chat.count`, null));
  const chat = useRef(null);
  const input = useRef(null);
  const [mailing, setMailing] = useState(false);
  const [dialog, setDialog] = useState([]);
  const [client, setClient] = useState(null);
  const [value, setValue] = useState('');
  const [tiket, setTiket] = useState(null);
  const [loading, setLoading] = useState(false);
  const [newMessage, setNewMessage] = useState(null);
  const [ticketsNone, setTicketsNone] = useState(false);
  const [closeDialog, setOpenCloseDialog] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const role = useSelector((state) =>
    get(state, `fetch.language.dataSource.role`, null),
  );

  const { data: tiketsOpen, getData: getOpen } = useFetch(TIKETS, {
    uniqId: 'tikets-open',
    autoFetch: false,
  });

  const { data: tiketsClose, getData: getClose } = useFetch(TIKETS, {
    uniqId: 'tikets-close',
    autoFetch: false,
  });

  useEffect(() => {
    getOpen({
      open: 1,
    });
    getClose({
      open: 0,
    });
  }, []);

  const openCloseDialog = async (id) => {
    dispatch(setId(id));
    try {
      setLoading(true);
      setOpenCloseDialog(true);
      const messages = await request(`v1${TIKETS}/${id}/messages`);
      const tiket = await request(`v1${TIKETS}/${id}/`);
      setClient(tiket.client);
      setTiket(tiket);
      await request(
        `v1${TIKETS}/_/messages/${messages[messages.length - 1].id}`,
        { method: 'patch', data: { read: true } },
      );
      const dateMessages = uniqBy(
        map(messages, (item) => item.created_at.split('T')[0]),
      );
      const emptyDataForDialog = map(dateMessages, (item) => {
        return { [item]: [] };
      });
      each(emptyDataForDialog, (item) => {
        const date = Object.keys(item)[0];
        return each(messages, (message) => {
          if (message.created_at.split('T')[0] === date) {
            item[date].push(message);
          }
        });
      });

      setDialog(emptyDataForDialog);
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const openDialog = async (id, filteredData) => {
    dispatch(setId(id));
    try {
      setOpenCloseDialog(false);
      setLoading(true);
      const tiket = await request(`v1${TIKETS}/${id}/`);
      // dispatch(setCount(countMess - tiket.unread_messages_count));
      dispatch(setCount(countMess - (tiket.unread_messages_count > 0 ? 1 : 0)));

      const messages = await request(`v1${TIKETS}/${id}/messages`);
      await request(
        `v1${TIKETS}/_/messages/${messages[messages.length - 1].id}`,
        { method: 'patch', data: { read: true } },
      );

      const dateMessages = uniqBy(
        map(messages, (item) => item.created_at.split('T')[0]),
      );
      const emptyDataForDialog = map(dateMessages, (item) => {
        return { [item]: [] };
      });

      each(emptyDataForDialog, (item) => {
        const date = Object.keys(item)[0];
        return each(messages, (message) => {
          if (message.created_at.split('T')[0] === date) {
            item[date].push(message);
          }
        });
      });

      setDialog(emptyDataForDialog);
      setClient(tiket.client);
      let clone = Object.assign({}, tiket);
      setTiket({ ...clone, unread_messages_count: 0 });
      const newData = filter(
        filteredData ? filteredData : tiketsOpen,
        (item) => item.id !== clone.id,
      );
      newData.push({ ...clone, unread_messages_count: 0 });
      dispatch(
        fetchSuccess({
          uniqId: 'tikets-open',
          response: { data: newData },
        }),
      );

      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const webSocket = useCreation(() => {
    const token = localStorage.getItem('access_token');
    return new WebSocket(`${MONITORING}?authorization=OAuth%20${token}`);
  });

  useEffect(() => {
    webSocket.onopen = () => {
      console.log('open');
    };
    webSocket.onclose = () => console.log('ws closed');
    return () => {
      webSocket.close();
    };
  }, []);

  useEffect(() => {
    if (tiketsOpen) {
      webSocket.onmessage = function (event) {
        const message = JSON.parse(event.data);
        if (message.type === 'new_message') {
          setNewMessage(message.data);
          let clone;
          each(tiketsOpen, (item) => {
            if (item.id === message.data.ticket_id) {
              clone = Object.assign({}, item);
            }
          });
          const newData = filter(
            tiketsOpen,
            (item) => item.id !== message.data.ticket_id,
          );
          clone.last_message = message.data;
          newData.push({
            ...clone,
            unread_messages_count:
              clone.id === idTiket ? 0 : ++clone.unread_messages_count,
          });
          dispatch(
            fetchSuccess({
              uniqId: 'tikets-open',
              response: { data: newData },
            }),
          );
        } else if (message.type === 'update_ticket') {
          const newData = filter(
            tiketsOpen,
            (item) => item.id !== message.data.id,
          );
          if (newData.length !== 0) {
            openDialog(newData[0].id, newData);
            setClient(newData[0].client);
            setTiket(newData[0]);
          } else {
            setTicketsNone(true);
            setDialog([]);
            dispatch(
              fetchSuccess({
                uniqId: 'tikets-open',
                response: { data: [] },
              }),
            );
          }
        }
      };
    }
  }, [tiket, tiketsOpen]);

  useEffect(() => {
    if (tiket) {
      chat.current.scrollIntoView({ behavior: 'auto', block: 'end' });
    }
    if (newMessage && dialog && newMessage.ticket_id === idTiket) {
      const lastDate = Object.keys(dialog[dialog.length - 1])[0];
      const date = newMessage.created_at.split('T')[0];
      if (moment(date) > moment(lastDate)) {
        dialog.push({ [date]: [].push(newMessage) });
      } else {
        each(dialog, (item) => {
          if (item[date]) {
            item[date].push(newMessage);
          }
        });
      }
      setDialog(dialog);
      setNewMessage(null);
    }
  }, [newMessage, dialog, tiket]);

  useEffect(() => {
    // console.log("Open tickets changed!");
    let unreadCount = 0;
    if (tiketsOpen) {
      tiketsOpen.forEach((ticket) => {
        // console.log(ticket);
        unreadCount += ticket.unread_messages_count > 0 ? 1 : 0;
      });
    }
    // console.log("unread tickets: " + unreadCount);
    dispatch(setCount(unreadCount));
  }, [tiketsOpen]);

  const handleMessage = (e) => {
    setValue(e.target.value);
  };

  const setMessage = async (value, access) => {
    if (access) {
      await request(`v1/${TIKETS}/${tiket.id}/messages`, {
        method: 'post',
        data: { text: value, one_time_access: true },
      });
    } else {
      await request(`v1/${TIKETS}/${tiket.id}/messages`, {
        method: 'post',
        data: { text: value },
      });
    }

    setValue('');

    const messages = await request(`v1${TIKETS}/${tiket.id}/messages`);

    const dateMessages = uniqBy(
      map(messages, (item) => item.created_at.split('T')[0]),
    );
    const emptyDataForDialog = map(dateMessages, (item) => {
      return { [item]: [] };
    });

    each(emptyDataForDialog, (item) => {
      const date = Object.keys(item)[0];
      return each(messages, (message) => {
        if (message.created_at.split('T')[0] === date) {
          item[date].push(message);
        }
      });
    });

    setDialog(emptyDataForDialog);
  };

  const handleClick = (access) => {
    if (value !== '') {
      setMessage(value, access);
    }
  };

  // const handleKey = (e) => {
  //   setMessage(e.target.value);
  // };

  // const newTick = async () => {
  //   await request(`v1${TIKETS}`, {
  //     data: { box_id: 68, text: 'Ничего не работает' },
  //   });
  // };

  const closeTicket = async () => {
    try {
      await request(`v1/${TIKETS}/${tiket.id}/close`, {
        method: 'post',
      });
    } catch (e) {
      console.log(e);
    }
  };

  // const newTicket = async () => {
  //   await request(`v1${TIKETS}`, {
  //     method: 'post',
  //     data: {
  //       box_id: 67,
  //       text: 'Ничего не работает',
  //     },
  //   });
  // };

  const handleKey = (e) => {
    if (e.keyCode === 13 && e.ctrlKey) {
      setMessage(e.target.value);
    }
  };

  const updateValue = (e) => {
    setValue(e.target.value);
  };

  return (
    <Row className="h-full">
      {/* <Button
        onClick={() => {
          newTicket();
        }}
      >
        new
      </Button> */}
      <Col className="h-full overflow-auto border-r-1 border-gray" span={9}>
        <Bar
          currentTiket={tiket ? tiket.id : null}
          open={reverse(sortBy(tiketsOpen, (item) => item.id))}
          close={tiketsClose}
          mailing={mailing}
          setMailing={setMailing}
          openDialog={openDialog}
          openCloseDialog={openCloseDialog}
        />
      </Col>
      <Col className="h-full" span={15}>
        <Row
          className={`h-full overflow-y-auto ${
            !tiket ? 'items-center justify-center' : null
          }`}
          type="flex"
          align={mailing ? 'stretch' : 'bottom'}
        >
          {!mailing && (
            <Col span={24}>
              <Spin spinning={loading}>
                <div ref={chat}>
                  <div className="pl-40 pt-40 pr-40 mb-20">
                    {dialog.length !== 0 && client
                      ? map(dialog, (item, index, array) => {
                          const date = Object.keys(item)[0];
                          return (
                            <div key={index}>
                              {moment(date).format('DD.MM.YYYY') ===
                              moment().format('DD.MM.YYYY') ? (
                                <Row className="mb-20">
                                  <Col className="flex items-center" span={11}>
                                    <div className="bg-darkGray h-1 w-11/12"></div>
                                  </Col>
                                  <Col className="text-center" span={2}>
                                    {' '}
                                    {t('today')}
                                  </Col>
                                  <Col
                                    className="flex items-center justify-end"
                                    span={11}
                                  >
                                    <div className="bg-darkGray h-1 w-11/12"></div>{' '}
                                  </Col>
                                </Row>
                              ) : moment(date).format('DD.MM.YYYY') ===
                                moment()
                                  .subtract(1, 'days')
                                  .format('DD.MM.YYYY') ? (
                                <Row className="mb-20">
                                  <Col className="flex items-center" span={11}>
                                    <div className="bg-darkGray h-1 w-11/12"></div>
                                  </Col>
                                  <Col className="text-center" span={2}>
                                    {' '}
                                    {t('yesterday')}
                                  </Col>
                                  <Col
                                    className="flex items-center justify-end"
                                    span={11}
                                  >
                                    <div className="bg-darkGray h-1 w-11/12"></div>{' '}
                                  </Col>
                                </Row>
                              ) : (
                                <Row className="mb-20">
                                  <Col className="flex items-center" span={11}>
                                    <div className="bg-darkGray h-1 w-11/12"></div>
                                  </Col>
                                  <Col className="text-center" span={2}>
                                    {' '}
                                    {date}
                                  </Col>
                                  <Col
                                    className="flex items-center justify-end"
                                    span={11}
                                  >
                                    <div className="bg-darkGray h-1 w-11/12"></div>{' '}
                                  </Col>
                                </Row>
                              )}
                              {map(item[date], (message, index, array) => {
                                if (
                                  (index !== 0 &&
                                    array[index - 1].manager &&
                                    message.manager &&
                                    moment(array[index - 1].created_at).format(
                                      'DD.MM.YYYY',
                                    ) ===
                                      moment(message.created_at).format(
                                        'DD.MM.YYYY',
                                      )) ||
                                  (index !== 0 &&
                                    !array[index - 1].manager &&
                                    !message.manager &&
                                    moment(array[index - 1].created_at).format(
                                      'DD.MM.YYYY',
                                    ) ===
                                      moment(message.created_at).format(
                                        'DD.MM.YYYY',
                                      ))
                                ) {
                                  return (
                                    <Message
                                      key={index}
                                      text={message.text}
                                      manager={message.manager}
                                      client={client}
                                    />
                                  );
                                } else {
                                  return (
                                    <Message
                                      key={index}
                                      text={message.text}
                                      manager={message.manager}
                                      date={message.created_at}
                                      client={client}
                                      avatar={true}
                                    />
                                  );
                                }
                              })}
                            </div>
                          );
                        })
                      : null}
                    {ticketsNone ? <Empty /> : null}
                  </div>
                  {!ticketsNone ? (
                    <Wrapper>
                      {tiket && !closeDialog ? (
                        <div className="pt-8 flex pb-8 pl-37 pr-37 bg-lightGray">
                          <div
                            style={
                              role === 'admin'
                                ? { width: '80%' }
                                : { width: '100%' }
                            }
                            className="relative"
                          >
                            <Input.TextArea
                              ref={input}
                              // onBlur={(e) => {
                              //   handleMessage(e);
                              // }}
                              placeholder={t('youMessage')}
                              style={{ resize: 'none' }}
                              bordered={false}
                              autoFocus={true}
                              onKeyUp={(e) => {
                                handleKey(e);
                              }}
                              value={value}
                              onChange={(val) => {
                                updateValue(val);
                              }}
                              // value={value}
                              // onPressEnter={(e) => {
                              //   handleKey(e);
                              // }}
                              className="rounded-md h-44"
                            />
                            <Plane
                              className="absolute cursor-pointer top-5 right-10"
                              onClick={() => {
                                handleClick();
                              }}
                            />
                          </div>
                          {tiket && !closeDialog ? (
                            tiket.one_time_access ? (
                              <Button
                                onClick={() => {
                                  handleClick('access');
                                }}
                                style={{ background: ' #F1F0F0' }}
                                className="border-2 border-red w-300 text-red ml-25 h-44 flex items-center justify-center"
                              >
                                <span>{t('giveAccess')}</span>
                              </Button>
                            ) : null
                          ) : null}
                          {role === 'admin' ? (
                            <Button
                              onClick={() => {
                                closeTicket();
                              }}
                              className="border-none  ml-25 bg-ghostblue h-44 flex items-center justify-center hover:bg-ghostblue"
                            >
                              <span className="pl-40 pr-40 text-primary">
                                {t('closeTicket')}
                              </span>
                            </Button>
                          ) : null}
                        </div>
                      ) : !closeDialog ? (
                        <div className="items-center flex-col justify-center flex uppercase text-graytext text-20">
                          {t('chatSection.chooseMsg')}
                          <div className="mb-10 mt-10">
                            <MailOutlined />
                          </div>
                        </div>
                      ) : null}
                    </Wrapper>
                  ) : null}
                </div>
              </Spin>

              {/* <Footer /> */}
            </Col>
          )}
          {mailing && (
            <>
              <Col span={24}>
                <div className="font-bold p-40 text-34 text-black">
                  {t('setTheTermsOfMailing')}
                </div>
                <div className="p-40 pt-0 pb-28">
                  <Filter placeholder="Quick search by tenant name, box number and id, section" />
                </div>
                <div className="pl-40 pr-40">
                  <div className="flex mb-14 items-center flex-wrap">
                    <Button
                      className="p-0 mr-3 ml-3 text-primary flex items-center"
                      type="link"
                    >
                      <span className="border-b-1 border-dotted">
                        {t('paid')}
                      </span>
                    </Button>
                    ,
                    <Button
                      className="p-0 mr-3 ml-3 text-primary flex items-center"
                      type="link"
                    >
                      <span className="border-b-1 border-dotted">
                        {t('paymentTermIsSuitable')}
                      </span>
                    </Button>
                    ,
                    <Button
                      className="p-0 mr-3 ml-3 text-primary flex items-center"
                      type="link"
                    >
                      <span className="border-b-1 border-dotted">
                        {t('paymentIsOverdue')}
                      </span>
                    </Button>
                    <div className="w-1 h-24 mr-27 ml-27 bg-darkGray">{` `}</div>
                    <Button
                      className="p-0 mr-3 ml-3 text-primary flex items-center"
                      type="link"
                    >
                      <span className="border-b-1 border-dotted">
                        {t('chatsection.lastAccess')}
                      </span>
                    </Button>
                    <div className="w-1 h-24 mr-27 ml-27 bg-darkGray">{` `}</div>
                    <Button
                      className="p-0 mr-3 ml-3 text-primary flex items-center"
                      type="link"
                    >
                      <span className="border-b-1 border-dotted">
                        {t('dateOfLastAccess')}
                      </span>
                    </Button>
                    <Button
                      className="p-0 mr-3 ml-3 text-primary flex items-center"
                      type="link"
                    >
                      <span className="border-b-1 border-dotted">
                        {t('lockProblemDate')}
                      </span>
                    </Button>
                  </div>
                </div>
              </Col>
              <Col className="mt-165" span={24}>
                <div className="p-40 pt-27 bg-lightGray">
                  <Input
                    placeholder={t('heading')}
                    className="rounded-md mb-10 h-44"
                  />
                  <Input.TextArea
                    className="rounded-md"
                    placeholder={t('yourMessage')}
                    rows={6}
                  />
                  <div className="pt-20 flex justify-end">
                    <div className="flex items-center">
                      <Button
                        type="link"
                        className="flex items-center font-semibold"
                        style={{ color: '#9F9F9F' }}
                      >
                        <Plane className="mr-11" />
                        <div>{t('send')}</div>
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="pl-40 pt-18 pr-40">
                  <Row>
                    <Col span={8}>
                      <div className="font-semibold mb-17">{t('var')}</div>
                      <div className="mb-10">
                        $name{' '}
                        <span className="text-graytext">— {t('nameUser')}</span>
                      </div>
                      <div className="mb-10">
                        $rented_boxes_count{' '}
                        <span className="text-graytext">
                          — {t('numberOfBoxesRentedByTheUser')}
                        </span>
                      </div>
                      <div className="mb-10">
                        $expired_boxes_count{' '}
                        <span className="text-graytext">
                          — {t('numberOfExpiredBoxes')}
                        </span>
                      </div>
                    </Col>
                    <Col className="flex justify-end flex-col" span={8}>
                      <div className="mb-10">
                        $name{' '}
                        <span className="text-graytext">— {t('nameUser')}</span>
                      </div>
                      <div className="mb-10">
                        $rented_boxes_count{' '}
                        <span className="text-graytext">
                          — {t('chatSection.noBoxesRented')}
                        </span>
                      </div>
                      <div className="mb-10">
                        $expired_boxes_count{' '}
                        <span className="text-graytext">
                          — {t('chatSection.noBoxesExpired')}
                        </span>
                      </div>
                    </Col>
                    <Col className="flex justify-end flex-col" span={8}>
                      <div className="mb-10">
                        $name{' '}
                        <span className="text-graytext">— {t('username')}</span>
                      </div>
                      <div className="mb-10">
                        $rented_boxes_count{' '}
                        <span className="text-graytext">
                          — {t('chatSection.noBoxesRented')}
                        </span>
                      </div>
                      <div className="mb-10">
                        $expired_boxes_count{' '}
                        <span className="text-graytext">
                          — {t('chatSection.noBoxesExpired')}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </>
          )}
        </Row>
      </Col>
    </Row>
  );
}

Chat.propTypes = {};

export default Chat;
